import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { forEach as _forEach } from 'lodash';
import { Button, Col, Row } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'axios';
import { S3_LINKS_DIV } from 'js/constants';
import LoaderCC from '../LoaderCC';
import { addNotification } from '../../../actions/NotificationsActions';
import EntityPropsUpdater from '../../../component/EntityPropsUpdater';
import FormInput from '../../forms/FormInput';
import FormRichEditor from '../../forms/FormRichEditor';
import FormAutocomplete from '../../forms/FormAutocomplete';
import Modal from '../../Modal';
import IntlDateTime from '../IntlDateTime';
import {getNameInCurrentLanguage} from "helpers/intl";
import {getAuthorizationLabel} from "helpers/order";


class LeadDeliveryData extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      printing: '',
      message: '',
      emailText: '',
      orderHistory: [],
      totalOrderStatus: '',
      showEdit: false,
      foreignIdSelect: undefined,
      processNumber: undefined,
      showing: '',
      addForeignId: '',
      trackingText: '',
      loadOrderMethods: false,
      orderCanPlace: false,
      orderByApi: false,
      orderByWebshop: false,
      orderByEmail: false,
    };
  }

  componentDidMount = () => {
    const { orderId, entity } = this.props;
    this.loadOrderCanPlace(orderId);
    this.getOrderStatus(entity.getOrders()[0].getId());
  };

  orderIt = (messages, supplierCode, orderId, emailText, originalEmailText) => {
    let email;
    if (emailText) {
      email = emailText;
    } else {
      email = originalEmailText;
    }
    this.setState({ printing: 'orderIt' });
    if (supplierCode === 'flyerAlarm') {
      this.sendOrderToFlyerAlarm(orderId)
        .then(response => {
          this.setState({ printing: '', totalOrderStatus: response.data.total_order_status }, () => {
            // this.setState({ printing: '', orderHistory: response.data.items[0].vendor_ordering, totalOrderStatus: response.data.total_order_status}, () => {
            this.updateEntity('vendorOrdering', response.data.items[0].vendor_ordering, ['orders', 0, 'items', 0]);
            this.updateEntity('changed', 'order');

            const options = {
              customUI: ({ onClose }) => {
                return (
                  <div className="react-confirm-alert-body">
                    <h1>{messages.supplier_order}</h1>
                    {response.data.authorization_successful ? (
                      <p>{messages.order_sended}</p>
                    ) : (
                      <p style={{ color: '#CD1318' }}>{messages.failure_when_ordering}</p>
                    )}

                    <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                      <Button
                        style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                        bsStyle="info"
                        onClick={onClose}
                      >
                        OK
                      </Button>
                    </div>
                  </div>
                );
              },
              childrenElement: () => <div />,
              closeOnEscape: true,
              closeOnClickOutside: true,
            };
            confirmAlert(options);
          });
        })
        .catch(() => {
          this.setState({ message: 'Could not send order!' });
        });
    } else if (supplierCode === 'orderByEmail') {
      this.sendOrderByEmail(orderId, email)
        .then(response => {
          this.setState({ printing: '', totalOrderStatus: response.data.total_order_status }, () => {
            // this.setState({ printing: '', orderHistory: response.data.items[0].vendor_ordering, totalOrderStatus: response.data.total_order_status}, () => {

            this.updateEntity('vendorOrdering', response.data.items[0].vendor_ordering, ['orders', 0, 'items', 0]);
            this.updateEntity('changed', 'order');

            const options = {
              customUI: ({ onClose }) => {
                return (
                  <div className="react-confirm-alert-body">
                    <h1>{messages.supplier_order}</h1>
                    <p>{messages.please_create_orderhistory_email}</p>
                    <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                      <Button
                        style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                        bsStyle="info"
                        onClick={onClose}
                      >
                        OK
                      </Button>
                    </div>
                  </div>
                );
              },
              childrenElement: () => <div />,
              closeOnEscape: true,
              closeOnClickOutside: true,
            };
            confirmAlert(options);
          });
        })
        .catch(() => {
          this.setState({ message: 'Could not send order!' });
        });
    }
  };

  // contact to API
  sendOrderToFlyerAlarm = orderId => {
    return axios.post(`/api/flyeralarm/placeorder/${orderId}.json`).catch(console.error);
  };

  /* TODO sendOrderByEmail muss noch APILink eingetragen werden */
  sendOrderByEmail = (orderId, emailText) => {
    console.error(`${this.constructor.name} sendOrderByEmail() method NOT IMPLEMENTED. Email text: ${emailText}`);
    return Promise.reject(new Error('Order by email not implemented'));
    // return axios.put(`/api/.../${orderId}.json`).catch(console.error);
  };

  emailTextChange = (name, value) => {
    this.setState({ emailText: value });
  };

  trackingTextChange = (name, value) => {
    this.setState({ trackingText: value });
  };

  changeVendorStatus = (foreignId, orderId, value) => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ printing: 'changeVendorStatus' });
    axios
      .put(`/api/flyeralarm/foreign/${foreignId}/order/${orderId}/status/${value}.json`)
      .then(response => {
        this.setState({ printing: '', totalOrderStatus: response.data.total_order_status }, () => {
          this.updateEntity('vendorOrdering', response.data.items[0].vendor_ordering, ['orders', 0, 'items', 0]);
          this.updateEntity('changed', 'order');

          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.change_of_status}</h1>
                  <p>{messages.new_status_set}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(console.error);
  };

  getOrderStatus = orderId => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ printing: 'getOrderStatus' });
    axios
      .put(`/api/flyeralarm/aggregateorderstatus/${orderId}.json`)
      .then(response => {
        this.setState({ printing: '', totalOrderStatus: response.data.total_order_status }, () => {
          this.updateEntity('vendorOrdering', response.data.items[0].vendor_ordering, ['orders', 0, 'items', 0]);
          this.updateEntity('changed', 'order');

          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.statusQuery}</h1>
                  <p>
                    {messages.totalStatus} {response.data.total_order_status}
                  </p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(console.error);
  };

  sendNewData = (messages, foreignId, orderId) => {
    this.setState({ printing: 'sendNewData' });
    axios
      .put(`/api/flyeralarm/uploads/${orderId}/printdata/${foreignId}.json`)
      .then(() => {
        this.setState({ printing: '' }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.printData}</h1>
                  <p>{messages.current_printdata_sended}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(console.error);
  };

  // TODO: this method does nothing, but is called onClick in case FA print data error
  newDataProof = () => {
    // const {
    //   intl: { messages },
    // } = this.props;
  };

  editShow = (i, show) => {
    if (show === 'open') {
      this.setState({
        foreignIdSelect: i,
        showEdit: true,
      });
    } else {
      this.setState({ showEdit: false });
    }

    if (show === 'opensAH') {
      this.setState({ showing: 'opensAH' });
    } else if (show === 'closesAH') {
      this.setState({ showing: 'closesAH' });
    }

    if (show === 'openaTN') {
      this.setState({
        processNumber: i,
        showing: 'openaTN',
      });
    } else if (show === 'closeaTN') {
      this.setState({ showing: 'closeaTN' });
    }
  };

  deleteOrder = (i, order) => {
    // this.editShow('', "closeaTN")
    // value = this.state.trackingText;
    const ordersBeforeDelete = order.items[0].vendorOrdering;
    const sliced3 = ordersBeforeDelete.slice(0, i);
    let sliced4 = [];

    if (i < ordersBeforeDelete.length - 1) {
      sliced4 = ordersBeforeDelete.slice(i + 1);
    }

    const ordersAfterDelete = [...sliced3, ...sliced4];
    const vendorOrdering = 'vendorOrdering';

    this.updateEntity(vendorOrdering, ordersAfterDelete, ['orders', 0, 'items', 0]);
    this.updateEntity('changed', 'order');
  };

  changeForeignId = (name, value, i) => {
    this.updateEntity(name, value, ['orders', 0, 'items', 0, 'vendorOrdering', i]);
    this.updateEntity('changed', 'order');
  };

  addTrackingNumber = (order, name, value, i) => {
    this.editShow('', 'closeaTN');
    const trackingNumbersDB = order.items[0].vendorOrdering[i].trackingNumbers;
    const trackingNumberValue = new Array(value);
    const trackingNumbersConcat = [...trackingNumbersDB, ...trackingNumberValue];
    this.updateEntity(name, trackingNumbersConcat, ['orders', 0, 'items', 0, 'vendorOrdering', i]);
    this.updateEntity('changed', 'order');
  };

  addForeignIdInModal = value => {
    this.setState({ addForeignId: value });
  };

  createOrderHistory = (orderId, itemId, type) => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ printing: 'createOrderHistory' });

    axios
      .put(`/api/orders/${orderId}/newvendorordering/${itemId}.json`, { type, internalComment: '' })
      .then(response => {
        this.updateEntity('vendorOrdering', response.data.items[0].vendor_ordering, ['orders', 0, 'items', 0]);
        this.updateEntity('changed', 'order');

        this.setState({ printing: '', totalOrderStatus: response.data.total_order_status }, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className="react-confirm-alert-body">
                  <h1>{messages.order}</h1>
                  <p>{messages.order_created}</p>
                  <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                    <Button
                      style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                      bsStyle="info"
                      onClick={onClose}
                    >
                      OK
                    </Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });
      })
      .catch(console.error);
  };

  loadOrderCanPlace = orderId => {
    axios
      .get(`/api/vendororder/canplace/${orderId}.json`)
      .then(response => {
        const { data } = response;
        this.setState({
          orderByApi: data.via_api,
          orderByEmail: data.via_email,
          orderByWebshop: data.via_webshop,
          orderCanPlace: data.can_place,
        });
      })
      .catch(console.error);
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      appIntl
    } = this.props;

    const {
      printing,
      emailText,
      totalOrderStatus,
      showEdit,
      foreignIdSelect,
      showing,
      processNumber,
      trackingText,
      orderCanPlace,
      orderByApi,
      orderByWebshop,
    } = this.state;

    if (!entityLoaded) {
      return <LoaderCC />;
    }

    const output = [];
    const orders = entity.getOrders();

    if (orders.length === 0) {
      output.push(<p>n. A.</p>);
    } else {
      const order = orders[0]; // so richtig sauber ist das nicht
      const itemVendor = order
        .getItems()[0]
        .getItem()
        .getVendor();
      const vendor = itemVendor.getUsername();

      const orderingBy = itemVendor.getVendorData().getOrderingBy();
      const vendorEmail = orderingBy.getOrderingEmailAddress();
      const vendorWebshop = orderingBy.getOrderingURL();

      let orderHistoryList;
      let _totalOrderStatus;

      const showOrderByForeignId = [];
      const showOrderByAPI = [];

      /* Const Flyeralarm */
      if (vendor === 'flyeralarmde') {
        showOrderByAPI.push(
          <div>
            <h4>Bestellung bei Flyeralarm per API</h4>
            <p>
              <i className="fa fa-cube" />
              <a
                href={
                  'https://www.flyeralarm.com/de/shop/option/index/id/' +
                  order.items[0].item.ident.vendorId +
                  '/quantity/' +
                  order.items[0].variant.ident.vendorId +
                  '/shipping/1/customizedId#options'
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                {' '}
                Zum Produkt auf Flyeralarm
              </a>
            </p>
            <Button
              style={{ margin: '0 auto', marginTop: '20px', marginBottom: '20px', width: '100px' }}
              bsStyle="primary"
              onClick={() => this.orderIt(messages, 'flyerAlarm', order.getId(), '', '')}
            >
              <i className={'far ' + (printing === 'orderIt' ? 'fa-spin fa-spinner-third' : 'fa-truck')} />{' '}
              {messages.order_it}
            </Button>
          </div>
        );
      } else {
        showOrderByAPI.push(<></>);
      }

      if (typeof totalOrderStatus && totalOrderStatus !== undefined) {
        _totalOrderStatus = totalOrderStatus;
      } else {
        _totalOrderStatus = order.totalOrderStatus;
      }

      _forEach(order.items, item => {
        if (item.getVendorOrdering().length > 0) {
          orderHistoryList = item.getVendorOrdering();
        }
      });

      const editionDataName = [];
      const editionDataValue = [];

      const items = order.getItems();
      if (items?.length) {
        _forEach(items, item => {
          if (item?.variant) {
            const { attributes } = item.variant;
            if (attributes?.length) {
              _forEach(attributes, attribute => {
                const { name: names, values } = attribute;
                if (names && values && names.length <= values.length) {
                  _forEach(names, (name, i) => {
                    const names2 = name.name;
                    const values2 = attribute.values[i].value;
                    if (names2 && values2) {
                      if (values2.length > 0) {
                        const value2 = values2[0].name;
                        editionDataName.push(names2);
                        editionDataValue.push(value2);
                      }
                    }
                  });
                }
              });
            }
          }
        });
      }
      let itemName;
      (typeof order?.items[0]?.name === 'object') ? itemName = getNameInCurrentLanguage(order?.items[0]?.name, appIntl) : itemName = order?.items[0]?.name;


      const { addressData } = order.shippingAddress;
      const logoImgUrl = S3_LINKS_DIV.CMS_IMAGE_THUMB_DEFAULT;
      const emailTextOriginal = `
        <div>
          <div>
            <p>Sehr geehrte Damen und Herren,</p><p>gerne möchten wir folgende Produkte bei Ihnen bestellen:</p>
          </div>
          <div style='margin-top:40px;margin-bottom:20px'>
              <h3>Produktliste:</h3>
              <table style='width:75%'>
              <tr><td><p>Menge</p></td><td><p>${order.items[0].quantity}</p></td></tr>
              <tr><td><p>Produktbezeichnung</p></td><td><p>${itemName}</p></td></tr>
              <tr><td><p>Produkt-Id</p></td><td><p>${order.items[0].variant.ident.vendorId}</p></td></tr>
              <tr><td><p>${editionDataName[0]}</p></td><td><p>${editionDataValue[0]}</p></td></tr>
              <tr><td><p>${editionDataName[1]}</p></td><td><p>${editionDataValue[1]}</p></td></tr>
              </table>
          </div>
          <div style='margin-top:20px;margin-bottom:20px'>
            <h3>Lieferadresse</h3>
            <address>
              ${addressData.company}<br />
              ${addressData.firstName} ${addressData.lastName}<br />
              ${addressData.street} ${addressData.houseNumber} ${
        addressData.apartmentNumber === null ? '' : ' / ' + addressData.apartmentNumber
      }<br />
              ${addressData.addressLine2 ? `${addressData.addressLine2}<br />` : ''}
              ${addressData.zipCode} ${addressData.city}<br />
            </address>
          </div>
          <div style='margin-top:20px;margin-bottom:20px'>
            <p>Vielen Dank</p><p>Mit freundlichen Grüßen</p>
            <hr style='background-color:#d22429; height:2px'>
            <img src='${logoImgUrl}' style='width:120px; margin-top:40px' />
            <p style='margin-top:40px; color:#d22429;'>CreaCheck GmbH</p>
            <a href='http://www.creacheck.com'><p>www.creacheck.com</p></a>
            <a href='https://www.facebook.com/creacheck'<p>Facebook</p></a>
            <p style='margin-top:40px'>Denisstraße 12-14 . 67663 Kaiserslautern</p><p> Tel. 0631 36613-0</p>
            <p style='margin-top:40px'> Gerbermühlstraße 11 . 60594 Frankfurt am Main</p><p> Tel. 069 26490684-0</p>
            <p style='margin-top:40px'>HRB Kaiserslautern Nr. 32805</p>
            <p>Geschäftsführer: Dipl.-Betriebswirt (BA) Alexander Weimer</p>
            <p>Steuer-Nr.: 19/651/41833</p>
          </div>
        </div>
        `;

      const vendorDetails = [];

      _forEach(orderHistoryList, (vendorOrderings, i) => {
        const foreignStatus = vendorOrderings.foreignStatus || vendorOrderings.foreign_status;
        const foreignId = vendorOrderings.foreignId || vendorOrderings.foreign_id;

        /* Const Flyeralarm */
        if (vendor === 'flyeralarmde') {
          showOrderByForeignId.push(
            <p style={{ overflowWrap: 'break-word' }}>
              <a
                href={`https://www.flyeralarm.com/de/shop/customer/orderprint/orderId/${foreignId}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {foreignId}
              </a>
            </p>
          );
        } else {
          showOrderByForeignId.push(<p style={{ overflowWrap: 'break-word' }}>{foreignId}</p>);
        }

        const options = [
          foreignStatus,
          'None',
          'Order Accepted',
          'in Missing Print data',
          'Invalid (Print data)',
          'Accepted (Print data)',
          'Contact support service',
          'Payment pending',
          'in Production',
          'in Shipping',
          'Delivered',
          'in Complaint',
          'Accomplished',
          'Canceled',
          'in Unknown state',
        ];

        vendorDetails.push(
          <Row
            className="orders"
            style={{
              border: '1px solid #e1e1e3',
              marginTop: '5px',
              padding: '10px',
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            <Col md={1}>
              <p>{i + 1}</p>
            </Col>
            <Col md={2}>
              {['mail', 'webshop'].includes(vendorOrderings?.type) && (
                <Button
                  style={{ margin: '5px', width: '110px' }}
                  bsStyle="warning"
                  onClick={() => this.editShow(i, 'open')}
                >
                  <i className="far fa-edit" /> {messages.edit}
                </Button>
              )}
              {showOrderByForeignId[i]}
            </Col>
            <Col md={2}>
              {['mail', 'webshop'].includes(vendorOrderings?.type) && foreignId !== undefined && (
                <FormAutocomplete
                  onChange={(_, value) => {
                    this.changeVendorStatus(foreignId, order.getId(), value);
                  }}
                  value={foreignStatus}
                  label="Aktueller Status"
                  name="Status"
                  options={options.map(option => ({ label: option, value: option }))}
                />
              )}
              <p>
                {printing === 'changeVendorStatus' ? <i className="far fa-spin fa-spinner-third" /> : <></>}{' '}
                {foreignStatus}
              </p>
            </Col>
            <Col md={2}>
              <p>
                <IntlDateTime date={vendorOrderings.orderDate} />
              </p>
            </Col>
            <Col md={2}>
              {['canceled', 'Invalid (Print data)', 'in Missing Print data'].includes(foreignStatus) && (
                <Button
                  style={{ margin: '0 auto', width: 'max-content' }}
                  bsStyle="primary"
                  onClick={() => this.sendNewData(messages, foreignId, order.getId())}
                >
                  <i className={'far ' + (printing === 'sendNewData' ? 'fa-spin fa-spinner-third' : 'fa-upload')} />
                  <span> Druckdaten erneut senden</span>
                </Button>
              )}

              {vendorOrderings.type === 'webshop' && vendorWebshop && (
                <Button
                  href={vendorWebshop}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="btn btn-info"
                  role="button"
                >
                  {printing === 'sendNewData' ? <i className="far fa-spin fa-spinner-third" /> : <></>} Webshop
                </Button>
              )}

              {foreignStatus === 'Invalid (Print data)' && (
                <Button style={{ margin: '0 auto', width: '150px' }} bsStyle="primary" onClick={this.newDataProof}>
                  <i className="fas fa-tasks" /> {messages.dataproof}
                </Button>
              )}
              {foreignStatus === 'in Shipping' && (
                <Button
                  style={{ margin: '0 auto', width: '175px' }}
                  bsStyle="primary"
                  onClick={() => this.editShow(i, 'openaTN')}
                >
                  <i className="fas fa-map-marker-alt" /> {messages.enter_trackingLink}
                </Button>
              )}
              {foreignStatus === 'None' && (
                <Button
                  style={{ margin: '0 auto', width: '175px', marginTop: '5px' }}
                  bsStyle="warning"
                  onClick={() => this.deleteOrder(i, order)}
                >
                  <i className="fal fa-trash-alt" /> {messages.delete}
                </Button>
              )}
            </Col>
            <Col md={1}>
              <p>{vendorOrderings.type}</p>
            </Col>
            <Col md={2}>
              <p>{vendorOrderings.internalComment}</p>
            </Col>
          </Row>
        );
      });

      // vendorid, bestellung über flyeralarm oder anderer lieferant
      const { orderAuthorizationList } = this.props;
      output.push(
        <div className="panel panel-transparent" key={order.getId()}>
          <div className="authorization-status">
            <Row style={{border: "none"}}>
              <Col md={12}>
                <h3>{messages.lead_authorization.authorization}</h3>
              </Col>
            </Row>
            <Row className="authorization-status-header">
              <Col md={12}>
                <h5><strong>{messages.authorization_status}</strong></h5>
              </Col>
            </Row>
              <Row>
                <Col md={6}>
                  <h5><strong>{messages.lead_authorization.type}</strong></h5>
                </Col>
                <Col md={6}>
                  <h5><strong>{messages.lead_authorization.status}</strong></h5>
                </Col>
              </Row>
              {orderAuthorizationList.map(auth => {
                return <Row>
                  <Col md={6}>
                    <p>{getAuthorizationLabel(auth?.type, messages) !== '-' ? getAuthorizationLabel(auth?.type, messages) : auth?.type}</p>
                  </Col>
                  <Col md={6}>
                    <p>
                      {
                        auth?.isAuthorized ? <>{messages.lead_authorization.approved}</> :
                        auth?.isRejected ? <>{messages.lead_authorization.rejected}</> :
                        <>{messages.lead_authorization.pending}</>
                      }
                    </p>
                  </Col>
                </Row>;
                })}
          </div>

          <Row>
            <Col md={12}>
              <h3>{messages.supplier_order}</h3>
            </Col>
          </Row>
          <Row>
            <div>
              <Row class="deliveryDataHeaders">
                <Col md={12}>
                  <h5>{messages.orders}</h5>
                </Col>
              </Row>
              <Row
                class="deliveryDataStyle"
                style={{
                  backgroundColor: '#FFFFFF',
                  padding: '10px',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #F0F0F0',
                }}
              >
                <Col md={1}>
                  <p>Nr.</p>
                </Col>
                <Col md={2}>
                  <p>{messages.foreignId}</p>
                </Col>
                <Col md={2}>
                  <p>{messages.orderStatus}</p>
                </Col>
                <Col md={2}>
                  <p>{messages.orderDate}</p>
                </Col>
                <Col md={2}>
                  <p>{messages.options}</p>
                </Col>
                <Col md={1}>
                  <p>{messages.type_}</p>
                </Col>
                <Col md={2}>
                  <p>{messages.comment_}</p>
                </Col>
              </Row>
              {vendorDetails}
            </div>
          </Row>
          <Row>
            <Col md={12}>
              <h3>
                <div>
                  <Row>
                    <Col md={12} style={{ padding: '10px' }}>
                      <p>{_totalOrderStatus}</p>
                    </Col>
                    <Col md={12}>
                      <Button
                        bsStyle="default"
                        style={{ margin: '0 auto', width: '190px' }}
                        onClick={() => this.getOrderStatus(order.getId())}
                      >
                        <i
                          className={
                            printing === 'getOrderStatus' ? 'far fa-spin fa-spinner-third' : 'fas fa-tasks-alt'
                          }
                        />{' '}
                        {messages.query_orderStatus}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </h3>
            </Col>
          </Row>
          <Row>
            <>
              <Col md={12} style={{ padding: '0' }}>
                <div>
                  {orderCanPlace && (
                    <div>
                      <Row
                        class="deliveryDataHeaders"
                        style={{ marginTop: '50px', marginBottom: '5px', padding: '10px' }}
                      >
                        <Col md={12}>
                          <h5>{messages.orderOptions}</h5>
                        </Col>
                      </Row>
                      {orderByApi && (
                        <Row
                          style={{ marginBottom: '5px', padding: '10px', border: '1px solid #e1e1e3', display: 'flex' }}
                        >
                          <Col md={12}>{showOrderByAPI}</Col>
                        </Row>
                      )}
                      {orderByWebshop && (
                        <Row
                          style={{ marginBottom: '5px', padding: '10px', border: '1px solid #e1e1e3', display: 'flex' }}
                        >
                          <Col md={12}>
                            <h4>{messages.ordering_by_webshop}</h4>
                            <p>
                              <a href={vendorWebshop} target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-store-alt" /> Zum Flyeralarm Webshop
                              </a>
                            </p>
                            <Button
                              style={{ margin: '0 auto', marginTop: '20px', marginBottom: '20px', width: '200px' }}
                              bsStyle="primary"
                              onClick={() => this.createOrderHistory(order.getId(), order.items[0].getId(), 'webshop')}
                            >
                              {printing === 'createOrderHistory' ? (
                                <i className="far fa-spin fa-spinner-third" />
                              ) : (
                                <i className="fas fa-history" />
                              )}{' '}
                              Bestellung anlegen
                            </Button>
                          </Col>
                        </Row>
                      )}
                      {/* orderByEmail ? if you dont want send email as default alternative */}
                      {orderCanPlace && (
                        <Row
                          style={{ marginBottom: '5px', padding: '10px', border: '1px solid #e1e1e3', display: 'flex' }}
                        >
                          <Col md={12}>
                            <h4>{messages.ordering_by_email}</h4>
                            <div>
                              <FormInput
                                type="text"
                                label={messages.email}
                                name="email"
                                onChange={() => {}}
                                value={vendorEmail}
                              />
                            </div>
                            <h5>{messages.info_to_the_emailOrder}</h5>
                            <FormRichEditor
                              name="halloname"
                              value={emailTextOriginal}
                              onChange={this.emailTextChange}
                            />
                            <Row>
                              <Col md={6}>
                                <Button
                                  style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                                  bsStyle="primary"
                                  onClick={() =>
                                    this.orderIt(messages, 'orderByEmail', order.getId(), emailText, emailTextOriginal)
                                  }
                                >
                                  <i className="far fa-truck" /> {messages.order_it}
                                </Button>
                              </Col>
                              <Col md={6}>
                                <Button
                                  style={{ margin: '0 auto', marginTop: '20px', marginBottom: '20px', width: '200px' }}
                                  bsStyle="primary"
                                  onClick={() => this.createOrderHistory(order.getId(), order.items[0].getId(), 'mail')}
                                >
                                  {printing === 'createOrderHistory' ? (
                                    <i className="far fa-spin fa-spinner-third" />
                                  ) : (
                                    <i className="fas fa-history" />
                                  )}{' '}
                                  Bestellverlauf anlegen
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}
                    </div>
                  )}
                </div>
              </Col>
            </>
          </Row>

          {foreignIdSelect !== undefined && (
            <Modal show={showEdit} onHide={() => this.editShow('', 'close')}>
              <Modal.Header closeButton>
                <h3>{messages.add_or_edit_foreignId}</h3>
              </Modal.Header>
              <Modal.Body>
                <Row className="mediainfo">
                  <Row>
                    <div className="form-group-attached">
                      <Col md={6}>
                        <FormInput
                          type="text"
                          label="Fremdbestellnummer"
                          name="foreignId"
                          onChange={(name, value) => {
                            this.changeForeignId(name, value, foreignIdSelect);
                          }}
                          value={
                            undefined === order.items[0].vendorOrdering || order.items[0].vendorOrdering.length === 0
                              ? ''
                              : undefined === order.items[0].vendorOrdering[foreignIdSelect] ||
                                undefined === order.items[0].vendorOrdering[foreignIdSelect].foreignId
                              ? ''
                              : order.items[0].vendorOrdering[foreignIdSelect].foreignId
                          }
                        />
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <div className="m-t-20 m-l-15">
                      <button type="button" onClick={() => this.editShow('', 'close')}>
                        <i className="fa fa-save" /> {messages.save}
                      </button>
                    </div>
                  </Row>
                </Row>
              </Modal.Body>
            </Modal>
          )}

          {processNumber !== undefined && (
            <Modal show={showing === 'openaTN'} onHide={() => this.editShow('', 'closeaTN')}>
              <Modal.Header closeButton>
                <h3>{messages.create_trackingLink}</h3>
              </Modal.Header>
              <Modal.Body>
                <Row className="mediainfo">
                  <Row>
                    <div className="form-group-attached">
                      <Col md={6}>
                        <FormInput
                          type="text"
                          label={messages.enter_trackingLink}
                          name="trackingNumbers"
                          onChange={(name, value) => {
                            this.trackingTextChange(name, value);
                          }}
                          value={trackingText}
                        />
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <div className="m-t-20 m-l-15">
                      <button
                        type="button"
                        onClick={() => this.addTrackingNumber(order, 'trackingNumbers', trackingText, processNumber)}
                      >
                        {messages.save}
                      </button>
                    </div>
                  </Row>
                </Row>
              </Modal.Body>
            </Modal>
          )}
        </div>
      );
    }

    return <div className="clearfix padding-25 sm-padding-10">{output}</div>;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadDeliveryData)
);
